<div class="demo-shell">
    <nav class="demo-shell__sidebar">
        <h3 class="demo-shell__title">Widget Demos</h3>
        <a *ngFor="let route of routes"
           class="demo-shell__link"
           [routerLink]="route.path"
           routerLinkActive="demo-shell__link--active">
            {{ route.label }}
        </a>
    </nav>
    <main class="demo-shell__content">
        <router-outlet></router-outlet>
    </main>
</div>
